<template>
  <div
    class="mt-6"
    data-test-id="product-reviews-media-carousel"
  >
    <div class="mb-4 flex items-center between">
      <h3 class="my-2 body-1 fw-bold ">
        {{ $t.reviewsPhotosAndVideos }}
      </h3>
      <vf-carousel-controls :carousel-ref />
    </div>

    <vf-carousel-elevate
      ref="carouselRef"
      :aria-label="`${$t.userSubmitted} ${$t.products.one}`"
      role="group"
      :show-arrows="false"
      :show-pagination="false"
    >
      <base-button
        v-for="(review, i) in reviewUgcMedia"
        :key="i"
        :aria-label="`${$t.reviewUgcViewInPopup} - ${i + 1}`"
        style="margin: 0 0.125rem"
        @click=" DialogReviewUgc.keep().open({
          productId,
          reviewUgcMedia,
          activeIndex: i,
        })"
      >
        <base-picture
          v-if="review.media[0].type === 'image'"
          :alt="review.media[0].caption"
          fit="cover"
          height="162"
          :props-img="{ class: 'aspect-square w-a', style: 'height: 10.125rem' }"
          :src="review.media[0].uri"
          width="162"
        />
        <base-video
          v-else-if="review.media[0].type === 'video'"
          class="aspect-square"
          :src="review.media[0].uri"
          style="height: 10.125rem"
        />
      </base-button>
    </vf-carousel-elevate>
    <dialog-review-ugc class-content="md:w-128" />
  </div>
</template>

<script lang="ts" setup>
import type { ProductReviewsReviewMedia } from '#root/api/clients/product/data-contracts'

const { media, productId } = defineProps<{
  media: ProductReviewsReviewMedia[]
  productId: string
}>()

const { DialogReviewUgc } = useDialogsStore()

const carouselRef = ref()

const reviewUgcMedia = computed(() =>
  media?.slice(0, 7).map((item) => ({
    reviewId: item.review_id,
    details: {
      // @ts-expect-error incorrect contract: "nickname" is missing
      nickname: item.nickname || '',
      headline: '',
      locale: '',
      location: '',
      // @ts-expect-error incorrect contract: "created_date" is missing
      createdDate: item.created_date,
      updatedDate: 0,
      comments: '',
      properties: []
    },
    metrics: {
      helpfulVotes: item.helpful_votes,
      notHelpfulVotes: item.not_helpful_votes,
      rating: 0,
      helpfulScore: 0
    },
    media: [item],
    ugcId: 0,
    legacyId: 0,
    badges: {
      isStaffReviewer: false,
      isVerifiedBuyer: false,
      isVerifiedReviewer: false
    }
  })) || []
)
</script>
